// PDF React View
import MessageBox from "components/shared-components/MessageBox";
import ReactPdfViewer from "components/shared-components/ReactPdfViewer";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";
import {
  previewPdfErrorInvoice,
  resetPreviewPdfErrorInvoice,
} from "store/actions";
const PDFViewModal = props => {
  const { isOpen, toggle, dataViewDocument, isTaxDeduct } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation(["issueInvoice"]);

  const errorInvoices = useSelector(state => state.errorInvoices);
  const { previewPdfErrorFile } = errorInvoices;
  useEffect(() => {
    if (isOpen) {
      dispatch(
        previewPdfErrorInvoice(
          dataViewDocument.id,
          dataViewDocument.path,
          isTaxDeduct
        )
      );
    } else {
      dispatch(resetPreviewPdfErrorInvoice());
    }
  }, [isOpen]);

  const styleDiv = {
    width: "100%",
    height: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#8080802b",
  };

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        {/* <ModalHeader toggle={toggle}>
          <Label>Bản hiển thị hóa đơn</Label>
        </ModalHeader> */}
        <ModalBody>
          {previewPdfErrorFile.loading ? (
            <div style={styleDiv}>
              <Spinner color="primary" />
            </div>
          ) : previewPdfErrorFile.error ? (
            <div style={styleDiv}>
              <MessageBox
                variant="danger"
                classMore="d-sm-flex align-items-center justify-content-center gap-1 font-size-18"
              >
                <i className="bx bxs-error-alt"></i>File không còn tồn tại
              </MessageBox>
            </div>
          ) : (
            <React.Fragment>
              <div>
                {previewPdfErrorFile.data && (
                  <React.Fragment>
                    <ReactPdfViewer
                      filePdfUrl={previewPdfErrorFile.data}
                      style={{ height: "75vh" }}
                    />
                  </React.Fragment>
                )}
              </div>
            </React.Fragment>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={!previewPdfErrorFile.data}
            onClick={() => {
              const link = document.createElement("a");
              link.href = previewPdfErrorFile.data;
              const fileName = isTaxDeduct
                ? "error-tax-deduct.pdf"
                : "error-invoice.pdf";
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
            }}
          >
            <i className="bx bx-download label-icon" />
            Download{" "}
            {`${
              dataViewDocument?.path === "review-pdf"
                ? "bản hiển thị"
                : "kết quả xử lý"
            }`}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

PDFViewModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dataViewDocument: PropTypes.any,
  isTaxDeduct: PropTypes.bool,
};

export default PDFViewModal;
